import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { TextInput } from '@/components/form/fields/text/TextInput';
import CatalogueExplorerFilterContainer from '@/pages/product/filters/catalogueExplorer/CatalogueExplorerFilterContainer';
import { productExplorerStrings } from '@/pages/product/strings';
import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { CataloguePageHeader } from '../Header';
import { AllProducts } from '../products/AllProducts';
import { CategoryProducts } from '../products/CategoryProducts';
import { SpecFilterGroup } from '../products/useFilteredProducts';

interface CatalogueExplorerProps {
  header: {
    step: number;
    title: string;
    subtitle?: string;
    breadcrumbs: NavPage[];
    controls?: ReactNode;
  };
  navigate: (to: string) => void;
  infoCard?: ReactNode;
  productIds?: string[];
  showCategories?: boolean;
  customFilterContent?: JSX.Element;
}

const CatalogueExplorer: FunctionComponent<CatalogueExplorerProps> = ({
  header,
  infoCard,
  productIds,
  customFilterContent
}) => {
  const { categoryId } = useParams();

  useEffect(() => {
    setSearchQuery('');
    setSpecFilter(undefined);
  }, [categoryId]);

  const [searchQuery, setSearchQuery] = useState<string>('');

  const [specFilter, setSpecFilter] = useState<SpecFilterGroup[]>();
  const [manufacturerFilter, setManufacturerFilter] = useState<string[]>();

  return (
    <div className="flex flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title={header.title} subtitle={header.subtitle} breadcrumbs={header.breadcrumbs}>
        {header.controls && <div className="flex gap-4">{header.controls}</div>}
      </CataloguePageHeader>
      <div className="overflow-y-auto">
        <div className="px-6 py-8 space-y-4">
          {infoCard && infoCard}
          <div className="flex space-x-4">
            <TextInput
              id="filter"
              className="flex-1"
              value={searchQuery}
              onChange={setSearchQuery}
              placeholder={productExplorerStrings.searchPlaceholder}
            />
          </div>
          <CatalogueExplorerFilterContainer
            categoryId={categoryId}
            onFilterCallback={filters => {
              setSpecFilter(filters.specs);
              setManufacturerFilter(filters.manufacturers);
            }}
            customContent={customFilterContent}
          />
        </div>

        {categoryId ? (
          <CategoryProducts
            categoryId={categoryId}
            searchQuery={searchQuery}
            specFilter={specFilter}
            manufacturerFilter={manufacturerFilter}
          />
        ) : (
          <AllProducts
            carouselMode
            searchQuery={searchQuery}
            specFilter={specFilter}
            manufacturerFilter={manufacturerFilter}
            filterProductIds={productIds}
          />
        )}
      </div>
    </div>
  );
};

export default CatalogueExplorer;
